<template>
  <div>
    <div class="divider dparent">
      <b> گزارش کار {{ ezam.TarhName }}</b>
    </div>
    <app-history
      v-if="!ezam.ReportMessage"
      @clicked="showReportDialog = true"
      title="ثبت گزارش ماه جاری"
    />
    <div style="margin: 20px" v-else>{{ ezam.ReportMessage }}</div>
    <div v-if="isMobile">
      <app-report-history
        v-for="index in history.length"
        :key="index"
        :index="index - 1"
        :item="history[index - 1]"
        :ezam="ezam"
      >
      </app-report-history>
    </div>
    <div v-else>
      <v-data-table
        :items="history"
        item-key="YearMonth"
        :headers="historyHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        show-expand
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <br />
            <b>توضيحات فرد: </b>
            <span v-html="item.Des_Fard"></span>
            <br />
            <br />
            <b>توضيحات ستاد: </b>
            <span v-html="item.Des_Setad"></span>
            <br />
            <br />
          </td>
        </template>
        <template v-slot:[`item.Fard_Report`]="{ item }">
          <span
            >{{ item.Fard_Report }}
            {{ ezam.TarhType == 1 ? "روز" : "ساعت" }}</span
          >
        </template>
        <template v-slot:[`item.Setad_Report`]="{ item }">
          <span
            >{{ item.Setad_Report }}
            {{ ezam.TarhType == 1 ? "روز" : "ساعت" }}</span
          >
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="showReportDialog"
      max-width="600"
      persistent
      content-class="myDialog"
    >
      <v-row align="center">
        <v-col class="d-flex" cols="5" sm="4"> کارکرد ماه اخیر </v-col>
        <v-col class="d-flex" cols="7" sm="3">
          <v-text-field
            v-model="ReportObject.Fard_Report"
            type="number"
          ></v-text-field>
          <span>{{ ezam.TarhType == 1 ? "روز" : "ساعت" }}</span>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> توضیحات </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-textarea
            outlined
            v-model="ReportObject.Des_Fard"
            no-resize
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn
          class="register"
          color="red white--text"
          rounded
          @click="closeSaveReport"
        >
          بستن
        </v-btn>
        <v-btn
          class="register"
          color="primary white--text"
          rounded
          @click="handleReport"
        >
          ثبت گزارش
        </v-btn>
      </v-row>
    </v-dialog>
  </div>
</template>

<script>
import HistoryButton from "@/components/HistoryButton";
import ReportHistory from "./ReportHistory";

import { GetWorkReportHistory, SaveReport } from "@/api/ezam";
import moment from "moment-jalaali";
export default {
  components: {
    appHistory: HistoryButton,
    appReportHistory: ReportHistory,
  },
  props: ["ezam"],
  data() {
    return {
      history: [],
      showReportDialog: false,
      ReportObject: {
        Fard_Report: 0,
        Des_Fard: "",
      },
      initSaveReport: {
        Fard_Report: 0,
        YearMonth: "",
        Srl_TabliqEzam: 0,
        Des_Fard: "",
      },
      historyHeaders: [
        {
          text: "تاریخ گزارش",
          value: "YearMonth",
        },
        {
          text: "گزارش فرد",
          value: "Fard_Report",
        },
        {
          text: "تایید ستاد",
          value: "Setad_Report",
        },

        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],

      headerProps: {
        sortByText: "مرتب سازی بر اساس",
      },
    };
  },
  created() {
    this.getWorkReportHistory();
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    getWorkReportHistory() {
      GetWorkReportHistory({ Fserial: this.ezam.Fserial })
        .then((response) => {
          const data = response.data;
          this.history = data;
          this.$store.commit("SET_TABLE_TEXT", false);
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    getState(state) {
      switch (state) {
        case 0:
          return "نیازمند تایید";
        case 1:
          return "تایید شده";
        case 2:
          return "رد شده";
      }
    },

    showSaveReport() {
      this.showReportDialog = true;
      //this.$store.dispatch("getEmtiazDetails", formSerial);
    },
    closeSaveReport() {
      this.showReportDialog = false;
      this.ReportObject = { ...this.initSaveReport };
      //this.$store.dispatch("getEmtiazDetails", formSerial);
    },
    handleReport() {
      this.ReportObject.Srl_TabliqEzam = this.ezam.Fserial;
      this.ReportObject.YearMonth = moment().format("jYYYY/jMM");
      SaveReport(this.ReportObject)
        .then((response) => {
          this.$store.commit("SET_SNACKBAR_TEXT", response.data.Message);
          this.closeSaveReport();
          this.getWorkReportHistory();
        })
        .catch((error) => {
          this.$store.commit("SET_SNACKBAR_TEXT", response.data.Message);
        });
    },
  },
};
</script>
<style scoped>
.grid {
  margin: 10px 0;
}
.indent {
  margin-right: 30px;
}
.register {
  max-width: 100px !important;
}
</style>
